var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isShowGuide)?_c('MultiIndex',{attrs:{"qdata":_vm.qdata,"begin":_vm.begin}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }